<template>
    <div>
        <breadCrumb :data="breadCrumb" />    
        <div class="cardBox">
            <b-card header="header" class="general"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="house" />
                    <h5> {{$t('account.wizzard.generalInfo')}} </h5>
                </template>
                <ul class="info">
                    <li v-for="field in infoFields.info" :key="field.key">
                        <strong> {{field.label}} </strong> 
                         <span v-if="field.key == 'address'"> {{ renderData(field.keys,'info') + accountDetail.address.country.name + " "
                             + accountDetail.address.city.name +" "+ accountDetail.address.town.name  }}</span>
                        <span v-else-if="field.type == 'date'"> {{ moment(renderData(field.keys,'info'))}}</span>
                        <span v-else> {{ renderData(field.keys, 'info')}} </span>
                    </li>
                </ul>
            </b-card>
            <b-card header="header" class="subInfo" v-if="accountDetail.part_list && accountDetail.part_list.length > 0"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="grid" />
                    <h5 > {{$t('account.details.partInfo')}} </h5>
                </template>
               
                <b-table-simple>
                    <b-thead>
                        <b-th  v-for="field in infoFields.part" :key="field.key" > {{field.label}} </b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="part in accountDetail.part_list" :key="part.part_no">
                            <b-td v-for="field in infoFields.part" :key="field.key"> {{  renderData(field.keys, 'array', part, field.type) }}</b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>

            <b-card header="header" class="subInfo"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="star" />
                    <h5 > {{$t('account.details.subInfo')}} </h5>
                </template>
                 <b-table-simple>
                    <b-thead>
                        <b-th  v-for="field in infoFields.subscribe" :key="field.key" > {{field.label}} </b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="sub in accountDetail.account_info.customer.subs" :key="sub.id">
                            <b-td v-for="field in infoFields.subscribe" :key="field.key"> {{  renderData(field.keys, 'array', sub, field.type) }}</b-td>
                            
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
               
            </b-card>
            <b-card header="header" class="subInfo" v-if="accountDetail.account_vacations && accountDetail.account_vacations.length > 0"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="lock" />
                    <h5> {{$t('account.details.vacationInfo')}} </h5>
                </template>
               
                <b-table-simple>
                    <b-thead>
                        <b-th  v-for="field in infoFields.vacation" :key="field.key" > {{field.label}} </b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="vac in accountDetail.account_vacations" :key="vac.id">
                            <b-td v-for="field in infoFields.vacation" :key="field.key"> {{  renderData(field.keys, 'array', vac, field.type) }}</b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>

            <b-card header="header" class="subInfo" v-if="accountDetail.zones && accountDetail.zones.length > 0"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="columns-gap" />
                    <h5 > {{$t('account.details.zoneList')}} </h5>
                </template>
               
                <b-table-simple>
                    <b-thead>
                        <b-th  v-for="field in infoFields.zones" :key="field.key" > {{field.label}} </b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="zone in accountDetail.zones" :key="zone.id">
                            <b-td v-for="field in infoFields.zones" :key="field.key"> {{  renderData(field.keys, 'array', zone) }}</b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>

            <b-card header="header" class="general" v-if="accountDetail.hours && accountDetail.hours.length > 0"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="clock-history" />
                    <h5> {{$t('account.wizzard.workHours')}} </h5>
                </template>
                <WorkHours :edit="false" :modalType="pageSettings" :modalEvent="openModal" :hourList="accountDetail.hours ? accountDetail.hours : []"/>
            </b-card>


            <b-card header="header" class="subInfo" v-if="accountDetail.system_user && accountDetail.system_user.length > 0"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="people" />
                    <h5 > {{$t('account.details.userList')}} </h5>
                </template>
                <b-table-simple>
                    <b-thead>
                        <b-th  v-for="field in infoFields.panelUser" :key="field.key" > {{field.label}} </b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="user in accountDetail.system_user" :key="user.id">
                            <b-td v-for="field in infoFields.panelUser" :key="field.key"> 
                                <span v-if="field.type == 'Bool'" >
                                    <b-icon v-if="renderData(field.keys, 'array', user) !== 0" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> 
                                    <b-icon v-else icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                                </span>
                                <span v-else > {{ renderData(field.keys, 'array', user)}}</span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>

            <b-card header="header" class="subInfo" v-if="accountDetail.contact_user && accountDetail.contact_user.length > 0"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="people" />
                    <h5> {{$t('account.details.contactList')}} </h5>
                </template>
               
                <b-table-simple>
                    <b-thead>
                        <b-th  v-for="field in infoFields.user" :key="field.key" > {{field.label}} </b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="user in accountDetail.contact_user" :key="user.id">
                            <b-td v-for="field in infoFields.panelUser" :key="field.key"> 
                                <span v-if="field.type == 'Bool'" >
                                    <b-icon v-if="renderData(field.keys, 'array', user) !== 0" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> 
                                    <b-icon v-else icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                                </span>
                                <span v-else > {{ renderData(field.keys, 'array', user)}}</span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>

            <b-card header="header" class="subInfo" v-if="accountDetail.account_alerts && accountDetail.account_alerts.length > 0"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="bell" />
                    <h5> {{$t('account.wizzard.alarmState')}} </h5>
                </template>
               
                <b-table-simple>
                    <b-thead>
                        <b-th  v-for="field in infoFields.alarmState" :key="field.key" > {{field.label}} </b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="alert in accountDetail.account_alerts" :key="alert.id">
                            <b-td v-for="field in infoFields.alarmState" :key="field.key"> 
                                <span v-if="field.type == 'Bool'" >
                                    <b-icon v-if=" renderData(field.keys, 'array', alert, field.type) !== true" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> 
                                    <b-icon v-else icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                                </span>
                                <span v-else >
                                {{  renderData(field.keys, 'array', alert, field.type) }}

                                </span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>

             <b-card header="header" class="subInfo" v-if="accountDetail.account_com_control && accountDetail.account_com_control.length > 0"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="broadcast-pin" />
                    <h6 > {{$t('account.details.comTypes')}} </h6>
                </template>
               
                <b-table-simple>
                    <b-thead>
                        <b-th  v-for="field in infoFields.communicate" :key="field.key" > {{field.label}} </b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="acc in accountDetail.account_com_control" :key="acc.id">
                            <b-td v-for="field in infoFields.communicate" :key="field.key"> {{  renderData(field.keys, 'array', acc, field.type) }}</b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>

            <b-card header="header" class="general" v-if="accountDetail.notes && accountDetail.notes.length > 0"> 
                <template v-slot:header  >
                    <b-icon class="icons" variant="primary" icon="clipboard" />
                    <h6 > {{$t('account.details.notes')}} </h6>
                </template>
               
                <b-table-simple>
                    <b-thead>
                        <b-th  v-for="field in infoFields.notes" :key="field.key" > {{field.label}} </b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="note in accountDetail.notes" :key="note.id">
                            <b-td v-for="field in infoFields.notes" :key="field.key"> 
                                <span v-if="field.type == 'date'"> {{ moment(renderData(field.keys, 'array', note))}}</span>
                                <span v-else-if="field.type == 'HTML'" v-html="renderData(field.keys, 'array', note)"/>
                                <span v-else-if="field.type == 'Bool'" >
                                    <b-icon v-if="renderData(field.keys, 'array', note)" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> 
                                    <b-icon v-else icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                                </span>
                                <span v-else > {{ renderData(field.keys, 'array', note)}}</span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>

        </div>
        
    </div>
</template>

<script>
    import InfoCard from './components/InfoCard'
    import BreadCrumb from '@/components/BreadCrumb'
    import moment from 'moment'
    import WorkHours from "@/components/WorkHours"
    import i18n from '@/plugins/i18n';

    let infoFields = {
        info:[
            {key: "accountNo", label: i18n.t('account.form.accountCode'), keys: ['account_info', 'account', 'account_no'] },
            {key: "part", label: i18n.t('account.form.part'), keys: ['PartNo']  },
            {key: "name", label: i18n.t('account.form.name'), keys: ['name']},
            {key: "type", label: i18n.t('account.form.type'), keys: ['account_type', 'name']},
            {key: "job", label: i18n.t('account.form.job'), keys: ['job', 'name']},
            {key: "dealer", label: i18n.t('account.details.technicalService'), keys: ['customer', 'customer_company']},
            {key: "brand", label: i18n.t('account.details.panelBrand'), keys: ['account_info', 'account', 'panel_brand', 'name']},
            {key: "model", label: i18n.t('account.details.panelModel'), keys: ['account_info', 'account', 'panel_model', 'name']},
            {key: "protocol", label: i18n.t('account.details.comProtocol'), keys: ['account_info', 'account', 'signal_protocol', 'name']},
            {key: "connectDate", type:"date", label: i18n.t('account.details.connectionDate'),   keys: ['account_info', 'account', 'connectiond_date']},
            {key: "address", label: i18n.t('account.details.address'), keys: ['address', 'address']},
        ],
        part:[
            {key: "partNo", label: i18n.t('account.details.partNo'), keys:["part_no"]},
            {key: "name", label: i18n.t('account.details.subName'), keys:["name"]}
        ],
        subscribe: [
            {key: "name", label: i18n.t('account.details.subscriptionName'), keys:["sub","name"]},
            {key: "beginDate", type:"date", label: i18n.t('account.details.beginDate'), keys:["begin_date"]},
            {key: "expriyDate", type:"date", label: i18n.t('account.details.endDate'), keys:["end_date"]},
        ],
        vacation: [
            {key: "name", label: i18n.t('account.details.subscriptionName')},
            {key: "beginDate", label: i18n.t('account.details.beginDate')},
            {key: "expriyDate", label: i18n.t('account.details.endDate')},
        ],
        zones: [
            {key: "no", label: i18n.t('account.details.zoneNo'),  keys: [ 'zone_no'] },
            {key: "name", label: i18n.t('account.details.zoneName'), keys: [ 'name']},
            {key: "type", label: i18n.t('account.details.detectorType'), keys: ['zone_type', 'name']},
            {key: "services", label: i18n.t('account.details.serviceStatus'), keys: ['service_time']},
        ],
        panelUser: [
            {key: "no", label: i18n.t('account.details.orderNo'), keys: [ 'order_no']},
            {key: "name", label: i18n.t('account.details.panelUserName'), keys: [ 'name']},
            {key: "registerNo", label: i18n.t('account.details.registerNo'), keys: [ 'register_no']},
            {key: "alarm", type: "Bool", label: i18n.t('account.details.alarmType'), keys: [ 'alarm_type']},
        ],
        user: [
            {key: "no", label: i18n.t('account.details.priority')},
            {key: "name", label: i18n.t('account.details.userName')},
            {key: "phones", label: i18n.t('account.details.userPhone')},
            {key: "subscribes", label: i18n.t('account.details.userSubs')},
        ],
        alarmState: [
            {key: "signal_info", label: i18n.t('account.details.signalType'), keys: [ 'signal_info', 'name']},
            {key: "is_alert",  type: "Bool", label: "Alarm", keys: [ 'is_alert']},
        ],
        communicate: [
            {key: "com_type", label: i18n.t('account.details.comType'), keys: [ 'com_type']},
            {key: "tracking_time", label: i18n.t('account.details.trackingTime'), keys: [ 'tracking_time']},
            {key: "last_test_time", type:"date", label: i18n.t('account.details.lastSignalTime'), keys: [ 'last_test_time']},
        ],
        notes: [
            {key: "beginDate", type:'date', label: i18n.t('account.details.beginDate'), keys:['begin_date']},
            {key: "expriyDate", type:'date', label: i18n.t('account.details.endDate'), keys:['end_date']},
            {key: "title", label: i18n.t('account.details.noteHead'), keys:['title']},
            {key: "desc", type:'HTML', label: i18n.t('account.details.desc'), keys:['desc']},
            {key: "state", type:'Bool', label: i18n.t('account.details.status'), keys:['is_active']},
        ],
        hours: [
            {key: "beginDay", type:'Day', label: i18n.t('account.details.beginDate'), keys:['begin_day_id']},
            {key: "endDay", type:'Day', label: i18n.t('account.details.endDate'), keys:['end_day_id']},
            {key: "opening_time", label: i18n.t('account.details.openingTime'), keys:['opening_time']},
            {key: "closing_time", label: i18n.t('account.details.closingTime'), keys:['closing_time']},
            {key: "is_close", type:'Bool', label: i18n.t('account.details.offDay'), keys:['is_close']},
        ]
    }
    let Days = [i18n.t('general.days.mon'), i18n.t('general.days.tue'), i18n.t('general.days.wed'), i18n.t('general.days.thu'), i18n.t('general.days.fri'), i18n.t('general.days.sat'), i18n.t('general.days.sun')]
    
    let breadCrumb = [{ label: i18n.t('pages.account.name'), url: "/Accounts/List"}]
    export default {
        name: 'AccountDetail',
        created: async function(){
            await this.$store.dispatch('getAccountDetail', {id: this.$route.params.id})
            await  this.$store.dispatch('getAccountHours',{accountId: this.$route.params.id})
            let els = document.getElementsByClassName("subInfo");
            for(var i = 0; i < els.length; i++){
                if(i%2 == 1){
                    els[i].style.marginRight = 0;
                }
            }
        },
        computed:{
            accountDetail(){
                if(Object.keys(this.$store.getters.getAccountDetail).length>0){
                    this.breadCrumb = [
                        { label: this.$store.getters.getAccountDetail.account_info.account.account_no+" - "+ 
                            this.$store.getters.getAccountDetail.PartNo+" - "+this.$store.getters.getAccountDetail.name,
                            url: "/Accounts/"+this.$route.params.id }
                    ]
                    return this.$store.getters.getAccountDetail
                }else
                    return {} 
                
            }
        },
        data: () =>{
            return {
                 infoFields, breadCrumb, Days
            }
        },
        components:{
            InfoCard, BreadCrumb, WorkHours
        },
        methods:{
            renderData: function(data, type, obj, fType){
                let detail;
                if(data){
                    switch(type){
                        case 'info':
                            for(let i = 0; i<data.length; i++){
                                detail = detail ? detail[data[i]] : this.accountDetail[data[i]]
                            }
                            return detail 
                        case 'array':
                            for(let i = 0; i<data.length; i++){
                                if(fType && fType=="date"){
                                    detail = detail ? moment(detail[data[i]] ).format('DD MMMM YYYY HH:mm') :
                                     moment(obj[data[i]]).format('DD MMMM YYYY HH:mm')

                                }else if(fType && fType=="Day"){
                                    detail = detail ? this.Days[detail[data[i]]-1] :
                                     this.Days[obj[data[i]]-1]

                                } else {
                                    detail = detail ? detail[data[i]] : obj[data[i]]
                                }
                            }
                            return detail 
                    }
                }
                
            },
            moment: function(data){
                return moment(data).format('DD MMMM YYYY HH:mm');
            },
        }
    }
</script>

<style lang="css" scoped>
    @import "./styles/detail.min.css";
</style>



// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/Detail.vue